import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';

const Socials = () => {
  return (
    <div className='sm:w-1/2 md:w-1/4 h-auto sm:mt-0 mt-8'>
      <div className='text-green-dark mb-3 font-bold text-lg'>
        Follow Us
        <hr className='w-48 h-15' />
      </div>
      <div className='flex gap-4'>
        <a
          href='https://www.facebook.com/scopex.money'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaFacebook size={24}/>
        </a>
        <a
          href='https://www.instagram.com/scopex_fintech/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaInstagram size={24}/>
        </a>
        <a
          href='https://www.linkedin.com/company/0xscopex/'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaLinkedin size={24}/>
        </a>
        <a
          href='https://twitter.com/0xScopeX'
          target='_blank'
          rel='noopener noreferrer'
        >
          <FaTwitter size={24}/>
        </a>
      </div>
    </div>
  );
};

export default Socials;
